import { IApplicationState } from '../../types/redux';

export function selectProjectsList(state: IApplicationState) {
  return state.buildersProjects.data.projectsList;
}
